import React from 'react'
import "./css/ProjectCreation.css"
import FullScreenLoaderAnimation from "./FullScreenLoaderAnimation"
import {useHistory} from "react-router-dom"

import { ProjectCreationService} from "../../Services/DjangoServices"

export default function ProjectCreation(props) {
        const [cssClass, setCssClass] = React.useState("divOpen")
        const [projectNameWarningDisplay, setProjectNameWarningDisplay] = React.useState("")
        const [nextPage, setNextPage] = React.useState(false)
        const [projectName, setProjectName] = React.useState("")
        const [description, setDescription] = React.useState("")
        //for file uplodation
        const [file, SetFile] = React.useState(null);
        const [customFileName, SetCustomFileName] = React.useState("")
        const [realFileName, setRealFileName] = React.useState("")
        const [disableuploadbtn, SetUploadBtn] = React.useState(true);
        const [uploading, SetUploading] = React.useState(false);
        const [sizewarning, SetSizeWarning] = React.useState("none");
        const [warningtext, SetWarningText] = React.useState("");
        const [customFilenameWarning, setCustomFilenameWarning] = React.useState("")
        const history = useHistory();

        function InputOnchange(e) {
                if (e.target.files[0].size > 5242880) {
                        SetSizeWarning("block");
                        SetWarningText("This file is too big!!! file size lesser than 5 mb is acceptable");
                        setTimeout(() => {
                                SetSizeWarning("none");
                        }, 3000);
                }
                else if (e.target.files[0].name.split(".").slice(-1)[0] !== "csv") {
                        console.log(e.target.files[0].name.split(".").slice(-1)[0])
                        SetSizeWarning("block");
                        SetWarningText("Only csv files can be accepted!!!");
                        setTimeout(() => {
                                SetSizeWarning("none");
                        }, 3000);
                }
                else {
                        console.log(e);
                        SetFile(e.target.files[0])
                        setRealFileName(e.target.files[0].name)
                        SetUploadBtn(false)
                }
        }
        function discardComponent() {
                setCssClass("divClose");
                setTimeout(() => {
                        props.hideProjectCreation();
                }, 1500);
        }

        function projectNameValidation(e) {
                var p_name = e.target.value
                setProjectName(p_name)
                if (p_name === "" || /\s/.test(p_name) || /[-@!#$%^&*()<>?/|}{~:]/.test(p_name) || p_name.includes("\\")) {
                        setProjectNameWarningDisplay("project name cannot contain special characters except '_' and length should be greater than 5")
                        setTimeout(() => {
                                setProjectNameWarningDisplay("")
                        }, 5000)
                }
                else {
                        setProjectNameWarningDisplay("")
                }
        }
        function filenameValidation(e) {
                var f_name = e.target.value
                SetCustomFileName(f_name)
                if (/\s/.test(f_name) || /[-@!#$%^&*()<>?/|}{~:]/.test(f_name) || f_name.includes("\\")) {
                        setCustomFilenameWarning("Invalid filename cannot contain special characters")
                        setTimeout(() => {
                                setCustomFilenameWarning("")
                        }, 5000)
                }
                else {
                        setCustomFilenameWarning("")
                }
        }

        function createProjectRequest() {
                if (projectName === "" || /\s/.test(projectName) || /[-@!#$%^&*()<>?/|}{~:]/.test(projectName) || projectName.includes("\\") || projectName.length < 5) {
                        setProjectNameWarningDisplay("project name cannot contain special characters except '_' and length should be greater than 5")
                        setTimeout(() => {
                                setProjectNameWarningDisplay("")
                        }, 5000)
                        setNextPage(false)
                }
                else if (/\s/.test(customFileName) || /[-@!#$%^&*()<>?/|}{~:]/.test(customFileName) || customFileName.includes("\\")){
                        setCustomFilenameWarning("Invalid filename cannot contain special characters")
                        setTimeout(() => {
                                setCustomFilenameWarning("")
                        }, 5000)
                        setNextPage(true)
                }
                else {
                        SetUploading(true)
                        var formData = new FormData();
                        formData.append(
                                "project_name",
                                projectName
                        )
                        formData.append(
                                "description",
                                description
                        )
                        formData.append(
                                "dataset",
                                file,
                        )
                        formData.append(
                                "custom_filename",
                                customFileName
                        )
                        ProjectCreationService(formData).then((result) => {
                                if (result){
                                        console.log("limit exceed")
                                        var data = result.data
                                        if ("success" in data) {
                                                console.log(data);
                                                history.push("/project/preprocessing/" + data["project_key_name"])
                                        }
                                }
                                else {
                                        SetUploading(false)
                                        props.showProjectLimmitExceedModal()
                                }
                        }, (error) => {
                                console.log(error);
                        });
                }
        }
        return (
                <div id="project_creation_div" className={cssClass}>
                        <FullScreenLoaderAnimation animation_condition={uploading}/>
                        <div>
                                <i id="close_icon" className="fa fa-close" onClick={() => { discardComponent() }}></i>
                                {nextPage ?
                                        <div className="container mt-5 pt-5 p-0 w-75">
                                                <div className="row">
                                                        <div className="col-lg-6 col-md-6 col-sm-12">
                                                                <div className="container w-75" align="center" id="outer-upload-file">
                                                                        <input type="file" name="file" id="file" className="inputfile" max-input-size="5242880" accept=".csv" onChange={(e) => { InputOnchange(e) }} />
                                                                        <label className="btn btn-primary mt-2" htmlFor="file">Choose a file</label>
                                                                        <p className="mt-1 font-weight-bold" id="show-filename">{realFileName}</p>
                                                                </div>
                                                                <label className="text-danger" style={{ display: sizewarning }}>{warningtext}</label>
                                                                <hr></hr>
                                                                <label className="font-weight-bold">CUSTOM FILENAME:</label><br></br>
                                                                <input type="text" className="form-control" name="custom-filename" id="custom-filename" value={customFileName} onChange={(e) => { filenameValidation(e)}} placeholder="custom filename" />
                                                                <label className="text-danger" style={{ minHeight: "20px"}} >{customFilenameWarning}</label>
                                                        </div>
                                                </div>
                                                <div className="row mt-5 p-0 m-0">
                                                        <div className="col-lg-6 col-md-12">
                                                                <button className="btn btn-primary" onClick={() => { setNextPage(false) }}><i className="fa fa-arrow-left"></i>&nbsp; Previous</button>
                                                                <button className="btn btn-primary float-right" disabled={disableuploadbtn} onClick={() => { createProjectRequest() }}>Create</button>
                                                        </div>
                                                </div>
                                        </div>
                                        :
                                        <React.Fragment>
                                                <div className="container mt-5 pt-5">
                                                        <div className="row">
                                                                <div className="col-lg-5 col-md-6 col-sm-12">
                                                                        <label htmlFor="project_name" className="font-weight-bold">PROJECT NAME:</label>
                                                                        <input className="form-control" id="project_name" value={projectName || ''} placeholder="Enter Project Name" type="text" onChange={(e) => { projectNameValidation(e) }}></input>
                                                                        <label className="text-danger" id="projectname-warning" style={{ minHeight: "20px" }}>{projectNameWarningDisplay}</label>
                                                                </div>
                                                        </div>
                                                        <div className="row">
                                                                <div className="col-lg-5 col-md-6 col-sm-12">
                                                                        <label htmlFor="project_name" className="font-weight-bold">DESCRIPTION:</label>
                                                                        <textarea className="form-control" id="description" maxLength="250" value={description || ''} placeholder="About your project" type="text" onChange={(e) => { setDescription(e.target.value) }}></textarea>
                                                                </div>
                                                        </div>
                                                        <div className="row mt-5">
                                                                <div className="col-lg-5 col-md-6">
                                                                        <button className="btn btn-primary" onClick={() => { setNextPage(true) }}>Next &nbsp;<i className="fa fa-arrow-right"></i></button>
                                                                </div>
                                                        </div>
                                                </div>
                                        </React.Fragment>
                                }
                                <div className="row">
                                        <div className="col-lg-4 col-sm-6">
                                        </div>
                                        <div className="col-lg-4 col-sm-6">
                                                <img style={{ maxHeight: "500px" }} src={process.env.PUBLIC_URL + '/images/Workspace/create_project.png'} alt="data analysis" loading="eager"></img>
                                        </div>
                                </div>
                        </div>
                </div>
        )
}
